<script>

import CommonService from '../../services/common';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import Calendar from 'primevue/calendar';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import Dropdown from 'primevue/dropdown';
import {FilterMatchMode} from 'primevue/api';

import LabelField from '../../components/generic/LabelField.vue';
import GenericCustomAlert from '../../components/generic/GenericCustomAlert.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomMasterDataMultiSelect from '../../components/generic/GenericCustomMasterDataMultiSelect.vue';
import GenericJsonDialog from '../../components/generic/GenericJsonDialog.vue';
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue'
import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue'
import GenericDateOrTimeMask from '../../components/generic/GenericDateOrTimeMask.vue'

import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';

import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional

export default {
    props: ['configuration', 'category', 'name', 'onCellEditComplete', 'onRowSelectFn', 'defaultId', 'onDialogEditSave', 'onCellDeleteComplete', 'onRowSelectedChangeFn'],
    emits: [
        'showEquipmentDialog', 'showEquipmentOperationDialog', 'onDeleteRecord',
        'onTimesheetEditClick', 'populateCalculator', 'onStockManagementDailyTankDelete',
        'onLoadComplete', 'copyInTomorrowPlan', 'onStockManagementPipeDelete', 
        'onShowPaymentEmailDialog', 'onShowTheoreticalLotsDialog',
        'onOperativeLevelsDownloadExcelTemplate','onOperativeLevelsImportExcel',
        'onCloneFamilyPoolConfiguration', 'onStockManagementDailyTankManualLockTank', 
        'onStockManagementDailyTankManualUnlockTank', 'onExportToCalculator', 'onEditMtsDataItemClick',
        'showSchedulingAttachmentsDialog'
    ],
    components: {LabelField, GenericDateTimeMaskV2, GenericBooleanDropdown, Dropdown, GenericJsonDialog, DataTable, Column, InputText, TriStateCheckbox, Button, GenericCustomAlert, GenericCustomAutocompleteV2, GenericCustomMasterDataAutocompleteV2, GenericCustomMasterDataMultiSelect, Sidebar, Calendar, GenericDateOrTimeMask, ColumnGroup, Row},
    data(){
        return{
           loading: false,
            data: [],
            total: 0,
            //page: 1,
            params: {
                start: 0,
                limit: 25,
                sort: null,
                filter: ''
            },
            allData: [],
            queryParamFilters: {},
            sidebarFilters: {},
            filters: {},
            customActions: {},
            childrenCustomAction: {},
            winWidth: window.innerWidth,
            openFiltersSidebar: false,
            selectedItem: null,
            customToolbarItemsData: {},
            jsonAlertItem: {
                visible: false,
                title: ''
            },
            enableFilters: true,
            hideRefresh: false,
            defaultSortField: null,
            defaultSortOrder: null,
            expandedRows: [],
            editDialogVisible: false,
            editItem:  {},
            originalEditItem: {},
            detailsDialogVisible: false,
            detailsRecord: {},
            editingRows: [],
            globalFilters: [],
            prevSuccDialogVisible: false,
            prevRecord: {},
            succRecord: {},
            prevSuccColumnRecords: [],
            overlayPanelMessage: '',
            tooltipVisible: false
        }
    },
    created(){
        if(this.configuration){
            this.generateFilters();
            this.generateCustomActions();
            this.generateCustomToolbarItems();
            
            this.params.limit = this.configuration.defaultLimit ?? 25;
            this.defaultSortField = this.configuration.defaultSortField ?? this.configuration.idColumn;
            this.defaultSortOrder = this.configuration.defaultSortOrder ?? 1;
            let defaultSortStr = this.defaultSortOrder == 1 ? 'asc' : 'desc';
            this.params.sort = JSON.stringify([{property: this.defaultSortField.charAt(0).toUpperCase() + this.defaultSortField.slice(1), direction: defaultSortStr}]);
            let cacheData = this.$store.getters['cacheDataStore/getGridCache'](this.name);
            this.paginatorFirst = 0;
            if(cacheData){
                this.paginatorFirst = cacheData.start;
                if(cacheData.sort){
                    this.params.sort = cacheData.sort;
                    let parsed = JSON.parse(cacheData.sort)[0];
                    this.defaultSortField = parsed.property.charAt(0).toLowerCase() + parsed.property.slice(1);
                    this.defaultSortOrder = parsed.direction == 'asc' ? 1 : -1;
                }
            } 
            let firstItem = {first: this.paginatorFirst};

            if(!this.configuration.preventAutoLoad){
                this.onFilter(firstItem, true);
            }
            if(this.configuration.preventFilters){
                this.enableFilters = false;
            }
            if(this.configuration.hideRefresh){
                this.hideRefresh = true;
            }
        }
    },
    mounted(){
        window.addEventListener('resize', () => {
            this.winWidth = window.innerWidth;
        });
    },
    methods: {
        generateFilters(){
            this.filters = {};
            this.sidebarFilters = {};

            let cacheFilters = null;
            let cacheData = this.configuration.skipCache ? null : this.$store.getters['cacheDataStore/getGridCache'](this.name);
            if(cacheData){
                let filtersArray = JSON.parse(cacheData.filter);
                cacheFilters = {};
                for(let i = 0; i < filtersArray.length; i++){
                    let element = filtersArray[i];
                    cacheFilters[element.property] = element;
                }
            }

            for(let i=0; i<this.configuration.columns.length; i++){
                let column = this.configuration.columns[i];

                let defaultValue = column.defaultFilter ? column.defaultFilterValue : null;
                if(cacheFilters){
                    defaultValue = null;
                    switch(column.type){
                        case 'string':
                        case 'number':
                        case 'decimal':
                        case 'boolean':
                        // case 'select':
                        // case 'master-data-select':
                            if(column.name){
                                let cacheValue = cacheFilters[column.name.charAt(0).toUpperCase() + column.name.slice(1)];
                                if(cacheValue){
                                    defaultValue = cacheValue.value;
                                }
                            }
                        break;
                    }
                }

                if(column.type == 'string' || column.type == 'textarea'){
                    this.filters[column.name] = {
                        value:  defaultValue, matchMode: FilterMatchMode.CONTAINS, type: 'string'
                    };
                }else  if(column.type == 'json'){
                    this.filters[column.name] = {
                        value:  column.defaultFilter ? column.defaultFilterValue :'', matchMode: FilterMatchMode.CONTAINS, type: 'json', subKey: column.propName
                    };
                }else if(column.type == 'boolean'){
                    this.filters[column.name] = {
                        value: defaultValue, matchMode: FilterMatchMode.EQUALS, type: 'boolean'
                    };
                }else if(column.type == 'number' || column.type == 'decimal'){
                    this.filters[column.name] = {
                        value:  defaultValue, matchMode: FilterMatchMode.EQUALS, type: 'number'
                    };
                }else if(column.type == 'date'){ //{operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},

                    let defaultMatchMode = column.defaultFilterType ? column.defaultFilterType: FilterMatchMode.DATE_IS;
                    if(cacheFilters){
                        defaultValue = null;
                        let cacheValue = cacheFilters[column.name.charAt(0).toUpperCase() + column.name.slice(1)];
                        if(cacheValue){
                            defaultValue = new Date(cacheValue.value);
                            if(cacheValue.operator == '>='){
                                defaultMatchMode = FilterMatchMode.DATE_AFTER;
                            }else if(cacheValue.operator == '<='){
                                defaultMatchMode = FilterMatchMode.DATE_BEFORE;
                            }else if(cacheValue.operator == 'neq'){
                                defaultMatchMode = FilterMatchMode.DATE_IS_NOT;
                            }
                        }
                    }

                    this.filters[column.name] = {
                        value: defaultValue,
                        matchMode: defaultMatchMode,
                        type: 'date'
                    };
                }else if(column.type == 'select' || column.type == 'master-data-select'){ //{operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
                    this.filters[column.name] = {
                        value:  defaultValue, matchMode: FilterMatchMode.EQUALS, type: 'boolean'
                    };
                }

                if(column.gridFilterType){
                    if(column.gridFilterType == 'select' || column.gridFilterType == 'master-data-select'){
                        
                        if(cacheFilters){
                            defaultValue = null;
                            let cacheValue = cacheFilters[column.gridFilterName.charAt(0).toUpperCase() + column.gridFilterName.slice(1)];
                            if(cacheValue){
                                defaultValue = cacheValue.value;
                            }
                        }

                        this.filters[column.name] = {
                            value:  defaultValue,
                             matchMode: FilterMatchMode.EQUALS, type: 'select', toFilter: column.gridFilterName
                        };
                    }else if(column.gridFilterType == 'master-data-multi-select'){
                        if(cacheFilters){
                            defaultValue = null;
                            let cacheValue = cacheFilters[column.gridFilterName.charAt(0).toUpperCase() + column.gridFilterName.slice(1)];
                            if(cacheValue){
                                defaultValue = cacheValue.value;
                            }
                        }

                        this.filters[column.name] = {
                            value:  defaultValue, matchMode: FilterMatchMode.IN, type: 'multi-select', toFilter: column.gridFilterName
                        };
                    }
                }
            }

            if(this.$route.query){
                if(!this.$route.query.defaultVoyageNumber){
                    for (var [key, value] of Object.entries(this.$route.query)) {
                        this.filters[key] = {
                            value:  value, matchMode: FilterMatchMode.EQUALS, type: 'number'
                        };
                    }
                }
            }

        },
        generateCustomActions(){
            this.customActions = {};
            this.childrenCustomAction = {};

            let actions = this.configuration.customActions;
            if(actions){
                for(let i=0; i<actions.length; i++){
                    this.customActions[actions[i].name] = actions[i];
                }
            }

            let childrenActions = this.configuration?.children?.customActions;
            if(childrenActions){
                for(let i=0; i<childrenActions.length; i++){
                    this.childrenCustomAction[childrenActions[i].name] = childrenActions[i];
                }
            }

        },
        generateCustomToolbarItems(){
             if(this.configuration.toolbarActions){
                 let toolbarActions = this.configuration.toolbarActions;
                 for(let i=0; i<toolbarActions.length; i++){
                     if(toolbarActions[i].type == 'dropdown'){
                         this.customToolbarItemsData[toolbarActions[i].name] = null;
                     }
                }
            }
        },

        loadData(){
            this.loading = true;
            if(!this.configuration.preventAutoLoad){
                let cacheData = {
                    name: this.name,
                    filters: this.params
                };
                this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
            }

            CommonService.loadGeneric(this.configuration.api, this.configuration.queryParamFilters ? this.queryParamFilters : this.params, response => {
                this.loading = false;
                this.filterDialog = false;
                this.openFiltersSidebar = false;
                if(response.success){
                    this.data = response.data;
                    this.allData = response.data;
                    this.total = response.totalCount;
                    this.$emit('onLoadComplete', this.allData);
                }else{
                    this.data = [];
                    this.allData = [];
                    this.total = 0;
                }

                if(this.configuration.filterLocal){
                    this.onFilter({first: 0})
                }

            });
        },
        onPage(event){
            this.params.start = event.first;
            this.loadData();
        },
        onSort(event){
            let f = this.configuration.columns.filter(col => {
                return col.name == event.sortField;
            })
            if(f){
                if(this.configuration.filterLocal){
                    let field = event.sortField;
                    let fieldType = f.type;
                    let sortOrder = event.sortOrder;
                    this.data.sort((a,b) => {
                        let fieldA = fieldType == 'string' ? '' + a[field] : a[field];
                        let fieldB = fieldType == 'string' ? '' + b[field] : b[field];
                        
                        if(fieldA > fieldB){
                            return sortOrder;
                        }else if(fieldA < fieldB){
                            return sortOrder * -1;
                        }else{
                            return 0;
                        }
                    })
                    return;
                }
                let sortField = f[0].gridFilterName ? f[0].gridFilterName : event.sortField;
                this.params.sort = JSON.stringify([{property: sortField.charAt(0).toUpperCase() + sortField.slice(1), direction: event.sortOrder == 1 ? 'asc': 'desc'}])
            }else{
                this.params.sort = JSON.stringify([{property: event.sortField.charAt(0).toUpperCase() + event.sortField.slice(1), direction: event.sortOrder == 1 ? 'asc': 'desc'}])
            }
            if(this.data && this.data.length > 0){
                this.loadData();
            }
        },
        onFilter(event){
            this.params.start = event.first;
            let filters = [];
            let filteredItems = [...this.allData];
            
            for(var key in this.filters){
                
                if((this.filters[key].type == 'string' ) && this.filters[key].value){
                    if (this.configuration.filterLocal) {                        
                        filteredItems = filteredItems.filter((item) => {
                            return (item[key] && String(item[key]).toLowerCase().includes(String(this.filters[key].value).toLowerCase()))
                        })
                    } else{
                        let f = {
                            operator: 'like',
                            value: this.filters[key].value,
                            property: key.charAt(0).toUpperCase() + key.slice(1) 
                        }
    
                        filters.push(f);

                    }
                }else if((this.filters[key].type == 'json' ) && this.filters[key].value){
                    let f = {
                        operator: 'like',
                        value: this.filters[key].value,
                        property: key.charAt(0).toUpperCase() + key.slice(1) + '.' + 
                            this.filters[key].subKey.charAt(0).toUpperCase() + this.filters[key].subKey.slice(1)
                    }

                    filters.push(f);
                }else if(this.filters[key].type == 'number' && this.filters[key].value){

                    if (this.configuration.filterLocal) {
                        filteredItems = filteredItems.filter((item) => {
                            return item[key] && String(item[key]).toLowerCase().includes(String(this.filters[key].value).toLowerCase())
                        })
                    } else{

                        let f = {
                            operator: 'eq',
                            value: this.filters[key].value,
                            property: key.charAt(0).toUpperCase() + key.slice(1) 
                        }

                        filters.push(f);
                    }
                
                }else if(this.filters[key].type == 'decimal' && this.filters[key].value){
                    if (this.configuration.filterLocal) {
                        filteredItems = filteredItems.filter((item) => {
                            return item[key] && item[key].toLowerCase().includes(this.filters[key].value.toLowerCase())
                        })
                    } else{

                        let f = {
                            operator: 'eq',
                            value: this.filters[key].value,
                            property: key.charAt(0).toUpperCase() + key.slice(1) 
                        }

                        filters.push(f);
                    }
                
                }else if(this.filters[key].type == 'boolean' && this.filters[key].value != null){
                    if (this.configuration.filterLocal) {
                        filteredItems = filteredItems.filter((item) => {
                            return item[key] != null && (item[key] === this.filters[key].value)
                        })
                    } else{
                        let f = {
                            operator: 'eq',
                            value: this.filters[key].value,
                            property: key.charAt(0).toUpperCase() + key.slice(1) 
                        }

                        filters.push(f);
                    }

                }else if(this.filters[key].type == 'select' && this.filters[key].value != null){
                    if (this.configuration.filterLocal) {
                        filteredItems = filteredItems.filter((item) => {
                            return item[key] && (item[key] === (this.filters[key].value))
                        })
                    } else{
                        let f = {
                            operator: 'eq',
                            value: this.filters[key].value,
                            property: this.filters[key].toFilter.charAt(0).toUpperCase() + this.filters[key].toFilter.slice(1) 
                        }

                        filters.push(f);
                    }
                }else if(this.filters[key].type == 'date' && this.filters[key].value != null){

                    let operator = 'like';
                    if(this.filters[key].matchMode == FilterMatchMode.DATE_AFTER){
                        operator = '>=';
                    }else if(this.filters[key].matchMode == FilterMatchMode.DATE_BEFORE){
                        operator = '<=';
                    }else if(this.filters[key].matchMode == FilterMatchMode.DATE_IS_NOT){
                        operator = 'neq';
                    }

                    if (this.configuration.filterLocal) {
                        if(operator === 'like'){
                            filteredItems = filteredItems.filter((item) => {
                                return item[key] && new Date(this.utils.dateToCurrentTimeZone(item[key])).setHours(0,0,0,0).valueOf() == (new Date(this.filters[key].value).setHours(0,0,0,0).valueOf())
                            })
                        }else if(operator === '>='){
                            filteredItems = filteredItems.filter((item) => {
                                return item[key] && new Date(this.utils.dateToCurrentTimeZone(item[key])).setHours(0,0,0,0).valueOf() >= (new Date(this.filters[key].value).setHours(0,0,0,0).valueOf())
                            })
                        }else if(operator === '<='){
                            filteredItems = filteredItems.filter((item) => {
                                return item[key] && new Date(this.utils.dateToCurrentTimeZone(item[key])).setHours(0,0,0,0).valueOf() <= (new Date(this.filters[key].value).setHours(0,0,0,0).valueOf())
                            })
                        }else if(operator === 'neq'){
                            filteredItems = filteredItems.filter((item) => {
                                return item[key] && new Date(this.utils.dateToCurrentTimeZone(item[key])).setHours(0,0,0,0).valueOf() != (new Date(this.filters[key].value).setHours(0,0,0,0).valueOf())
                            })
                        }
                    } else{
                        let f = {
                            operator: operator,
                            value: this.filters[key].value,
                            property: key.charAt(0).toUpperCase() + key.slice(1) 
                        }
                        filters.push(f);
                    }
                }else if(this.filters[key].type == 'multi-select' && this.filters[key].value != null && this.filters[key].value.length > 0){
                    if (this.configuration.filterLocal) {
                        filteredItems = filteredItems.filter((item) => item[key].includes(this.filters[key].value))
                    } else{
                        let f = {
                            operator: 'in',
                            value: this.filters[key].value,
                            property: this.filters[key].toFilter.charAt(0).toUpperCase() + this.filters[key].toFilter.slice(1) 
                        }

                        filters.push(f);
                    }
                }
            }

            if(this.globalFilters != null && this.globalFilters.length > 0){
                filters.push(...this.globalFilters);
            }

            this.params.filter = JSON.stringify(filters);
            if(!this.configuration.filterLocal) {
                this.loadData();
            } else {
                this.data = [...filteredItems]
            }
        },
        onRefresh(){
            this.loadData();
        },
        onUpdate(data){
            if(this.configuration.editMode == 'dialog'){
                this.editItem = {...data};
                this.originalEditItem = {...data};
                for(let i=0; i<this.fieldsForDialogEdit.length; i++){
                    if(this.fieldsForDialogEdit[i].type == 'date'){
                        let field = this.fieldsForDialogEdit[i];
                        this.editItem[field.name] = this.editItem[field.name] ? new Date(Utils.dateToCurrentTimeZone(this.editItem[field.name])) : null;
                        this.originalEditItem[field.name] = this.editItem[field.name] ? new Date(Utils.dateToCurrentTimeZone(this.originalEditItem[field.name])) : null;
                    }else if(this.fieldsForDialogEdit[i].type == 'select'){
                        let field = this.fieldsForDialogEdit[i];
                        if(field.selectApiFn){
                            field.selectApi = field.selectApiFn(data)
                        }
                        field.disableStore = field.refreshOnUpdateDialog ? true: false;
                    }
                }
                
                this.editDialogVisible = true;
            }else{
                let uri = `/${this.category}/${this.name}/${data[this.configuration.idColumn]}`;
                this.$router.push(uri);
            }
        },
        onAdd(){
            if(this.configuration.addMode == 'dialog'){
                this.editItem = {};
                for(let i=0; i<this.fieldsForDialogEdit.length; i++){
                    this.editItem[this.fieldsForDialogEdit[i].name] = null;
                }
                this.editDialogVisible = true;
            }else{
                let uri = `/${this.category}/${this.name}/0`;
                this.$router.push(uri);
            }
        },
        onDelete(data){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    CommonService.deleteItem(this.configuration.api, data[this.configuration.idColumn], response => {
                            if(response.success){
                                this.$emit('onDeleteRecord');
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                                this.loadData();
                                if(this.onCellDeleteComplete){
                                    this.onCellDeleteComplete()
                                }
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        onCustomAction(name, data){
            if(this.customActions[name].type == 'window'){
                this.customActions[name].data=data;
                let ref = 'alert_' + this.customActions[name].name
                this.$refs[ref][0].show();
            }else{
                this.customActions[name].action(data, this);
            }
        },
        onChildrenCustomAction(name, data){
            this.childrenCustomAction[name].action(data, this);
        },
       onCustomDropdownChange(val, action){
           action(val, this);
       },
       openJsonDialog(value, label){
           this.jsonAlertItem.title= label;
           this.jsonAlertItem.value= value;
           this.jsonAlertItem.visible= true;
           this.$refs.jsonDialog.generateElement();
           this.$refs.jsonDialog.show();

       },
       resetGrid(){
            this.data = [];
            this.allData = [];
            this.total = 0;
       },
       filterFromView(filters, queryParamFilters = false){
            if(queryParamFilters){
                this.queryParamFilters = filters;
            }else{
                this.params.filter = JSON.stringify(filters);
            }
            this.loadData();
        },
        localFilter(){
            
        },
        formatInteger(n){
            if(n || n == 0){
                return n.toLocaleString();
            }
            return null;
        },
        formatDecimal(n, digits, showZero){
            if(!digits){
                digits = 2;
            }
            if(n){
                return n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits});
            }
            return showZero ? 0 : null;
            
        },
        cellDblClick(col, record){
            if(!this.configuration.editRule || this.configuration.editRule(record)){
                if(col.action){
                    col.action(this, record);
                }
            }
        },
        rowClass(data){
            let classes = "";
            if(this.configuration.highlightConditions){
                let highlightConditions = this.configuration.highlightConditions;

                for(let i=0; i<highlightConditions.length; i++){
                    let condition = highlightConditions[i];
                    if(condition.fn){
                        if(condition.fn(data[condition.field])){
                            classes += " " + condition.class;
                        }
                    }else{
                        if(data[condition.field] == condition.value){
                            classes += " " + condition.class;
                        }
                    }
                }
            }
            return classes;
        },
        onRowSelect(event){
            if(this.onRowSelectFn){
                this.onRowSelectFn(event.data);
            }
        },
        setSelectedItem(item){
            this.selectedItem = item;
        },
        afterCellEdit(event){
            if(this.onCellEditComplete){
                this.onCellEditComplete(event)
            }else if(this.configuration.onCellEditComplete){
                this.configuration.onCellEditComplete(event, this)
            }
        },
        dialogEditSave(){
            if(this.onDialogEditSave){
                this.onDialogEditSave(this.editItem, this.originalEditItem);
            }
        },
        hideDialogEdit(){
            this.editDialogVisible = false;
        },
        showDetails(data){
            this.detailsRecord = {...data};
            this.detailsDialogVisible = true;
        },
        onRowEditSave(e){
            CommonService.updateItem(this.configuration.api, e.newData, (response) => {
                if(response.success){
                    this.loadData();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        updateHideTimeField(params){
            params.elem[params.field] = params.hidetime;
        },
        setGlobalFilters(data){
            this.globalFilters = data;
        },
        showPrevSuccDetails(data){
            this.prevRecord = data[this.configuration.prevRecordName] ? JSON.parse(data[this.configuration.prevRecordName]) : null;
            this.succRecord = data[this.configuration.succRecordName] ? JSON.parse(data[this.configuration.succRecordName]) : null;
            this.generatePrevSuccRecords();
            this.prevSuccDialogVisible = true;
        },
        generatePrevSuccRecords(){
            this.prevSuccColumnRecords = [];
            if(this.prevRecord || this.succRecord){
                if(this.prevRecord){
                    for(let key in this.prevRecord){
                        this.prevSuccColumnRecords.push({
                            key: key,
                            prev: this.prevRecord ? this.prevRecord[key] : "",
                            succ: this.succRecord ? this.succRecord[key] : ""
                        })
                    }
                }else{
                    
                    for(let key in this.succRecord){
                        this.prevSuccColumnRecords.push({
                            key: key,
                            prev: this.prevRecord ? this.prevRecord[key] : "",
                            succ: this.succRecord ? this.succRecord[key] : ""
                        })
                    }

                }
            }
        },
        showConfirmPopup(event, message){
            this.overlayPanelMessage = message;
            
            this.tooltipVisible = true;
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        fieldsForDialogEdit(){
            let fields =  [];

            if(this.configuration && this.configuration.columns){
                fields = this.configuration.columns.filter(col => col.inLineEdit)
            }

            if(fields.some(item => item.name === 'noteScheduling') && !this.uiPermissions('noteSchedulingButton').isEnabled){
                fields = fields.filter(item => item.name !== 'noteScheduling');
            }

            return fields;
        },
        totalQuantity(){
            let total = 0;
            this.data.map(({quantity}) => total += quantity)
            return this.formatInteger(total);
        }
    },
    watch: {
        selectedItem(){
            if(this.onRowSelectedChangeFn){
                this.onRowSelectedChangeFn(this.selectedItem);
            }
        }
    }
};

</script>

<style lang="scss">
.grid-action-btn{
    width: 2rem !important;
    height: 2rem !important;
    margin: 2px !important;
}

.p-datatable-resizable .p-datatable-tbody > tr > td {
    white-space: normal;
}

.row-red {
    background-color: rgb(246, 71, 71) !important;
}

.row-yellow {
    background-color: yellow !important;
}

.row-azure {
    font-weight: bold;
    background-color: #DDEBF7 !important;
}

.field-column-streched {
    width: 150px;
    max-width: 100px;
}

.field-column {
    width: 150px;
}

.expand-column, .selection-column {
    max-width: 3rem;
}

.button-column {
    max-width: 140px;
    display: block !important;
}

</style>

<template>
    <Dialog v-model:visible="tooltipVisible" modal>
        <span v-html="overlayPanelMessage" />
    </Dialog>
        <Button :label="$t('btn.refresh')" icon="pi pi-sync" class="p-button-sm p-button-info mr-2" @click="onRefresh" v-if="!hideRefresh"/>
        <Button :label="$t('btn.add')" icon="pi pi-plus" class="p-button-sm p-button-success mr-2" @click="onAdd" v-if="configuration && configuration.enableInsert && uiPermissions(configuration.addButtonName).isEnabled" />
        <Button :label="$t('btn.filter')" icon="pi pi-filter" class="p-button-sm p-button-info mr-2" @click="openFiltersSidebar = true" v-show="configuration.sidebarFilters || winWidth < 960" />
    <span v-if="configuration">
        <span v-for="btn in configuration.toolbarActions" :key="btn.name">
            <Button v-if="(!uiPermissions(btn.name).isHidden) && btn.type == 'button'" :label="$t(btn.title)" :icon="btn.icon"  class="mr-2" :class="btn.cssClass" @click="btn.action(selectedItem, this)" :disabled="(typeof btn.disabled === 'function' ? btn.disabled(selectedItem, this) : false)  || !uiPermissions(btn.name).isEnabled"/>
            <Dropdown v-if="(!uiPermissions(btn.name).isHidden) && btn.type == 'dropdown'" :placeholder="$t(btn.label)" class="mr-2" :options="btn.options" v-model="customToolbarItemsData[btn.name]" @change="onCustomDropdownChange(customToolbarItemsData[btn.name], btn.action)" :disabled="!uiPermissions(btn.name).isEnabled"/>
        </span>
    </span>
        <DataTable :responsiveLayout="winWidth > 960 ? 'scroll' : 'stack'" breakpoint="960px" v-if="configuration"
            :loading="loading"
            :reorderableColumns="true"
            v-model:expandedRows="expandedRows"
            :value="data" :lazy="true" showGridlines stripedRows  ref="dt" :scrollable="winWidth > 960" :scrollHeight="winWidth > 960 ? 'flex' : '960'"
            :paginator="configuration.preventPagination ? false : true" :rows="params.limit" :first="paginatorFirst"
            v-model:filters="filters" @filter="onFilter($event)" filterDisplay="row" 
            :totalRecords="total" @page="onPage($event)"
            @sort="onSort($event)" :sortField="defaultSortField" :sortOrder="defaultSortOrder"
            v-model:selection="selectedItem"
            :editMode="configuration.editMode == 'row' ? 'row' : 'cell'" @cell-edit-complete="afterCellEdit" @rowSelect="onRowSelect" v-model:editingRows="editingRows" @row-edit-save="onRowEditSave"
            class="p-datatable-sm"
            :rowClass="rowClass"
            style="margin-top:20px;font-size:8px;">

            <ColumnGroup type="header" v-if="configuration.columnsGroups && configuration.columnsGroups.length > 0">
                <Row>
                    <Column :header="$t(col.header)" :colspan="col.colSpan" v-for="(col, index) in configuration.columnsGroups" :key="index" />
                </Row>
                <Row>
                    <Column :header="$t(col.label)" v-for="(col, index) in configuration.columns.filter((c) => !c.gridHide)" :key="index" :field="col.name"/>
                </Row>
            </ColumnGroup>

            <Column :rowEditor="true" bodyStyle="text-align:center" v-if="configuration.editMode == 'row' && !uiPermissions(configuration.inLineEditPermission).isHidden"/>

            <Column :expander="true" class="expand-column" :reorderableColumn="false" v-if="configuration && configuration.children"/>
            <Column class="selection-column" :selectionMode="(configuration && configuration.selection && configuration.selectionMode) ? configuration.selectionMode : 'single'"
             v-if="configuration && configuration.selection" :reorderableColumn="false"></Column>
            <Column class="button-column" :exportable="false" v-if="
                (configuration.alertField) || (configuration.showDetailDialog) || (configuration.alertFieldScheduling) ||
                (configuration.enableUpdate && !uiPermissions(configuration.editButtonName).isHidden) || 
                (configuration.enableDelete && !uiPermissions(configuration.deleteButtonName).isHidden) || 
                (configuration.customActions != null && configuration.customActions.length > 0 && 
                (configuration.customActions.some(({name}) => !uiPermissions(name).isHidden)))" :reorderableColumn="false">
                <template #body="slotProps">
                    <Button icon="pi pi-eye" class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1" v-tooltip="$t('details')" @click="showDetails(slotProps.data)" v-if="configuration.showDetailDialog" size="small" />
                    <Button icon="pi pi-pencil" class="p-button-sm p-button-rounded p-button-success mr-1 mb-1" v-tooltip="$t('btn.edit')" @click="onUpdate(slotProps.data)" v-show="configuration.enableUpdate && !uiPermissions(configuration.editButtonName).isHidden && (!configuration.editRule || configuration.editRule(slotProps.data))" :disabled="!uiPermissions(configuration.editButtonName).isEnabled" size="small" />
                    <Button icon="pi pi-trash" class="p-button-sm p-button-rounded p-button-warning mr-1 mb-1" v-tooltip="$t('btn.delete')" @click="onDelete(slotProps.data)" v-show="configuration.enableDelete && !uiPermissions(configuration.deleteButtonName).isHidden && (!configuration.deleteRule || configuration.deleteRule(slotProps.data))" :disabled="!uiPermissions(configuration.deleteButtonName).isEnabled" size="small" />
                    <Button v-for="{title, name, icon, cssClass, visible, disable} in configuration.customActions" v-tooltip="$t(title)" :key="name" :icon="icon" class="p-button-sm p-button-rounded mr-1 mb-1" :class="cssClass" @click="onCustomAction(name, slotProps.data)" v-show="(typeof visible === 'function' ? visible(slotProps.data) : true) && !uiPermissions(name).isHidden" :disabled="(disable && disable(slotProps.data)) || !uiPermissions(name).isEnabled" size="small" />
                    <Button v-if="configuration.alertField && slotProps.data[configuration.alertField]" icon="pi pi-info" class="p-button-danger p-button-rounded p-button-outlined mr-1 mb-1" v-tooltip="slotProps.data[configuration.alertField]" size="small" />
                    <Button v-if="configuration.alertFieldScheduling && slotProps.data[configuration.alertFieldScheduling] && !uiPermissions('noteSchedulingButton').isHidden" icon="fa-regular fa-clipboard" class="p-button-info p-button-rounded p-button-outlined mr-1 mb-1" v-tooltip="'Scheduling Note: ' + slotProps.data[configuration.alertFieldScheduling]" size="small" />
                </template>
            </Column>

            <Column v-if="configuration.showPrevSuccDialog" class="button-column" :exportable="false">
                <template #body="slotProps">
                    <Button icon="pi pi-eye" class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1" v-tooltip="$t('details')" @click="showPrevSuccDetails(slotProps.data)" size="small" />
                </template>
            </Column>

            <Column 
                :frozen="col.frozen"
                v-for="col of configuration.columns" :field="col.name" :header="$t(col.label)" :key="col.name" :dataType="col.type" 
                :class="configuration.strechColumn ? 'field-column-streched' : 'field-column'"
                :sortable="true"
                :ref="col.name" :showFilterMenu="col.type=='date'" :showFilterOperator="col.type=='date'"
                :hidden="col.gridHide">
                <template #body="element" >
                    <span  @dblclick="cellDblClick(col, element.data)" class="w-full h-full" :style="col.style ? col.style : ''" :class="col.cls ? col.cls(element.data) : {}">
                        <span v-if="col.type=='boolean'">
                            <span v-if="col.allowNull">
                                {{element.data[col.name] != null ? (element.data[col.name] ? $t('yes') : $t('no')): ''}}
                            </span>
                            <span v-else>
                                {{element.data[col.name] ? $t('yes'): $t('no')}}
                            </span>
                        </span>
                        <span v-else-if="col.type=='date' && col.datetime">
                            {{element.data[col.name] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data[col.name])) : null}}
                        </span>
                        <span v-else-if="col.type=='date'">
                            {{element.data[col.name] != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data[col.name])) : null}}
                        </span>
                        <span v-else-if="col.type == 'json'">
                            <Button icon="pi pi-info" class="grid-action-btn p-button-rounded p-button-outlined" @click="openJsonDialog(element.data[col.name],col.label)"/>
                            {{element.data[col.name][col.propName]}}
                        </span>    
                        <span v-else-if="col.type=='number'">
                            {{formatInteger(element.data[col.name])}}
                        </span>   
                        <span v-else-if="col.type=='decimal'">
                            {{formatDecimal(element.data[col.name], col.digits, col.showZero)}}
                        </span>  
                        <span v-else-if="col.type=='editor'" v-html="element.data[col.name]">
                            
                        </span>   
                        <span v-else-if="col.icon">
                            <i class="mr-2" :class="col.icon(element.data)"></i>{{ element.data[col.name]}}
                        </span>          
                        <span v-else>
                            <span v-if="col.localized && col.renderColumn">
                                {{$t(col.renderColumn(element.data))}}
                            </span>
                            <span v-else-if="col.localized">
                                {{$t(element.data[col.name])}}
                            </span>
                            <span v-else-if="col.renderColumn">
                                {{col.renderColumn(element.data)}}
                            </span>
                            <span v-else-if="col.textButton">
                                

                                <Button :label="element.data[col.name]" :class="'p-button-sm mr-2 ' + col.renderClass(element.data) " v-if="col.showButton(element.data)" @click="showConfirmPopup($event, col.tooltip(element.data, $t))" />
                            </span>
                            <span v-else>
                                {{element.data[col.name]}}
                            </span>
                        </span>
                    </span>
                    
                </template>
                <template #filter="{filterModel,filterCallback}" v-if="enableFilters">
                     <InputText 
                        type="text" 
                        v-model="filterModel.value" 
                        @keydown.enter="filterCallback()" 
                        class="p-column-filter" 
                        v-if="(col.type == 'string' || col.type == 'json' || col.type == 'textarea') && col.gridFilterType != 'select' && col.gridFilterType != 'master-data-select' && col.gridFilterType != 'master-data-multi-select'"/>
                    <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" class="p-column-filter" v-if="col.type == 'boolean' && col.gridFilterType != 'select'"/>
                    <InputText type="number" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" v-if="(col.type == 'number' || col.type == 'decimal') && col.gridFilterType != 'select' && col.gridFilterType != 'master-data-select' && col.gridFilterType != 'master-data-multi-select'"/>
                    <Calendar v-model="filterModel.value" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" @keydown.enter="filterCallback()" @date-select="filterCallback()" v-if="col.type == 'date' && col.gridFilterType != 'select' && col.gridFilterType != 'master-data-select' && col.gridFilterType != 'master-data-multi-select'"/>
                    <GenericCustomAutocompleteV2 
                        v-model="filterModel.value" 
                        @change="filterCallback()"
                        :api="col.gridFilterSelectApi"
                        v-if="col.gridFilterType == 'select'" 
                        :staticOptions="col.gridFilterStaticOptions"
                        :sortField="col.gridFilterSortField"
                        :format="col.gridFilterSelectFormat" />
                    <GenericCustomAutocompleteV2 
                        :name="col.selectName"
                        v-model="filterModel.value" 
                        @change="filterCallback()"
                        :api="col.gridFilterSelectApi"
                        v-if="col.gridFilterType == 'master-data-select'" 
                        :format="{label:'label',value:'value'}" />
                    <GenericCustomMasterDataMultiSelect 
                        :name="col.selectName"
                        v-model="filterModel.value" 
                        @change="filterCallback()"
                        :api="col.gridFilterSelectApi"
                        v-if="col.gridFilterType == 'master-data-multi-select'" 
                        :staticOptions="col.gridFilterArray"
                        :disableStore="col.gridFilterDisableStore"
                        :format="col.gridFilterSelectFormat" />

                </template>
                <template #editor="{ data, field }" v-if="col.inLineEdit && (!configuration.editMode || configuration.editMode == 'row') && (configuration.enableInlineEdit === undefined || configuration.enableInlineEdit) && !uiPermissions(configuration.inLineEditPermission).isHidden" >
                    <InputText 
                        v-if="col.type == 'string'" 
                        class="w-full"
                        :disabled="col.editEnabled && !col.editEnabled(data)"
                        v-model="data[field]" />
                    <InputText 
                        class="w-full" 
                        type="number" 
                        v-if="col.type == 'number'"
                        :disabled="col.editEnabled && !col.editEnabled(data)"
                        v-model="data[field]" />
                    <InputNumber
                        :disabled="col.editEnabled && !col.editEnabled(data)"
                        class="w-full" 
                        mode="decimal" :maxFractionDigits="col.digits"
                        v-if="col.type == 'decimal'"
                        v-model="data[field]" />
                    <generic-date-time-mask-v-2 
                        v-if="col.type == 'date'"    
                        v-model="data[field]"
                        :readonly="col.editEnabled && !col.editEnabled(data)"
                        mask="99/99/9999 99:99:99"
                        :unmask="true" />
                    <GenericDateOrTimeMask
                        v-if="col.type == 'dateortime'"    
                        :hideTimeField="data[col.hideTimeField]"
                        :hideTimeFieldName="col.hideTimeField"
                        v-model="data[field]"
                        :elem="data"
                        @updateHideTimeField="updateHideTimeField"
                        :readonly="col.editEnabled && !col.editEnabled(data)" />
                    <GenericBooleanDropdown
                        v-if="col.type == 'boolean'"
                        v-model="data[field]" 
                        :disabled="col.editEnabled && !col.editEnabled(data)"
                        class="w-full" />
                    <GenericCustomMasterDataAutocompleteV2
                        v-if="col.type == 'select'"
                        :name="field"
                        v-model="data[col.updateField ?? field]"
                        :disabled="col.editEnabled && !col.editEnabled(data)" 
                        :api="col.selectApi"/>
                    <Textarea 
                        class="w-full" 
                        v-if="col.type == 'textarea'"
                        :disabled="col.editEnabled && !col.editEnabled(data)"
                        v-model="data[field]" />
                    
                </template>
            </Column>

            <template #empty>
                {{$t('noRecordsFound')}}
            </template>
            <template #expansion="slotProps">
                <!-- <h4>{{$t(configuration.children.name + '.title')}}</h4> -->
                <DataTable :value="slotProps.data[configuration.children.name]" :reorderableColumns="true" :responsiveLayout="winWidth > 960 ? 'scroll' : 'stack'" breakpoint="960px" 
                    :scrollable="winWidth > 960" :scrollHeight="winWidth > 960 ? 'flex' : '960'"
                    class="p-datatable-sm" >
                    <Column :exportable="false" v-if="configuration.children.customActions" :reorderableColumn="false">
                        <template #body="slotProps">
                            <Button v-for="{title, name, icon, cssClass} in configuration.children.customActions" v-tooltip="$t(title)" :key="name" :icon="icon" class="p-button-sm p-button-rounded mr-2" :class="cssClass" @click="onChildrenCustomAction(name, slotProps.data)" v-show="!uiPermissions(name).isHidden" :disabled="!uiPermissions(name).isEnabled" />
                        </template>
                    </Column>
                    <Column v-for="col in configuration.children.colums" :field="col.name" :header="$t(configuration.children.name + '.' + col.label)" :key="col.name" :dataType="col.type" style="width: 110px">
                        <template #body="element">
                            <span class="w-full h-full" :style="col.style ? col.style : ''">
                                <span v-if="col.type=='boolean'">
                                    {{element.data[col.name] ? $t('yes'): $t('no')}}
                                </span>
                                <span v-else-if="col.type=='date' && col.datetime">
                                    {{element.data[col.name] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data[col.name])) : null}}
                                </span>
                                <span v-else-if="col.type=='date'">
                                    {{element.data[col.name] != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data[col.name])) : null}}
                                </span>
                                <span v-else-if="col.type == 'json'">
                                    <Button icon="pi pi-info" class="grid-action-btn p-button-rounded p-button-outlined" @click="openJsonDialog(element.data[col.name],col.label)"/>
                                    {{element.data[col.name][col.propName]}}
                                </span>    
                                <span v-else-if="col.type=='number'">
                                    {{formatInteger(element.data[col.name])}}
                                </span>   
                                <span v-else-if="col.type=='decimal'">
                                    {{formatDecimal(element.data[col.name], col.digits)}}
                                </span>                   
                                <span v-else>
                                    <span v-if="col.localized">
                                        {{$t(element.data[col.name])}}
                                    </span>
                                    <span v-else>
                                        {{element.data[col.name]}}
                                    </span>
                                </span>
                            </span>
                            
                        </template>
                    </Column>
                    <!-- <Column field="Counterparty" :header="$t('counterparty')" sortable></Column>
                    <Column field="IncotermCode" :header="$t('incoterm.fk')" sortable></Column>

                    <Column field="OriginCountry" header="OriginCountry" sortable></Column>
                    <Column field="PlaceOfLoading" header="PlaceOfLoading" sortable></Column>
                    <Column field="PortOrLocationOfLoading" header="PortOrLocationOfLoading" sortable></Column>

                    <Column field="DestinationCountry" header="DestinationCountry" sortable></Column>
                    <Column field="PlaceOfDischarge" header="PlaceOfDischarge" sortable></Column>
                    <Column field="PortOrLocationOfDischarge" header="PortOrLocationOfDischarge" sortable></Column>

                    <Column field="Product" :header="$t('product.fk')" sortable></Column>
                    <Column field="Quantity" :header="$t('movementInstructions.quantity')" sortable></Column>
                    <Column field="MinimumQuantity" :header="$t('movementInstructions.minimumQuantity')" sortable></Column>
                    <Column field="MaximumQuantity" :header="$t('movementInstructions.maximumQuantity')" sortable></Column> -->

                </DataTable>
            </template>
            <div v-if="configuration.showTotalQuantity" class="text-right m-3">
                <h4>{{$t('total') + ': ' + totalQuantity }}</h4>
            </div>
        </DataTable>
        <div v-if="configuration">
            <span v-for="custom in configuration.customActions" :key="custom.name">
                <GenericCustomAlert :ref="'alert_' + custom.name" v-if="custom.type == 'window'" :title="custom.title" :item="custom" :caller="this" />
            </span>
        </div>
        <GenericJsonDialog ref="jsonDialog" :item="jsonAlertItem" :caller="this" />
        <Sidebar v-model:visible="openFiltersSidebar" position="right" v-if="enableFilters">
            <div class="grid formgrid" >
                <div v-for="field in configuration.columns" :key="field.name" class="col-12" >
                    <div v-if="!field.gridHide" class="mt-3">
                        <div class="field-checkbox" v-if="field.type == 'boolean'">
                            <TriStateCheckbox :id="field.name" v-if="field.type == 'boolean'" v-model="filters[field.name].value" />
                            <label for="binary">{{$t(field.label)}}</label>
                        </div>
                        <span  v-else>
                            <label :for="field.name">{{$t(field.label)}}</label>
                            <InputText 
                                class="w-full" 
                                :id="field.name" 
                                type="text" 
                                v-if="field.type == 'string' && field.gridFilterType != 'select' && field.gridFilterType != 'master-data-select' && field.gridFilterType != 'master-data-multi-select'"
                                v-model="filters[field.name].value" />
                            <InputText 
                                class="w-full"
                                :id="field.name"
                                type="number" 
                                v-if="field.type == 'number' && field.gridFilterType != 'select' && field.gridFilterType != 'master-data-select' && field.gridFilterType != 'master-data-multi-select'"
                                v-model="filters[field.name].value" />
                            <Calendar 
                                class="w-full" 
                                :id="field.name"  
                                v-if="field.type == 'date' && field.gridFilterType != 'select' && field.gridFilterType != 'master-data-select' && field.gridFilterType != 'master-data-multi-select'" 
                                v-model="filters[field.name].value" 
                                dateFormat="dd/mm/yy" 
                                placeholder="dd/mm/yyyy"/>
                            <GenericCustomAutocompleteV2 :field="field"
                                class="w-full"
                                v-model="filters[field.name].value" 
                                :disabled="field.readOnly" 
                                :api="field.selectApi"
                                v-if="field.gridFilterType == 'select'" 
                                :format="field.selectFormat" />
                            <GenericCustomMasterDataAutocompleteV2 :field="field"
                                class="w-full"
                                :name="field.selectName"
                                v-model="filters[field.name].value" 
                                :disabled="field.readOnly" 
                                :api="field.gridFilterSelectApi"
                                v-if="field.gridFilterType == 'master-data-select'" 
                                :localized="field.localized"
                                :format="field.selectFormat" />
                            <GenericCustomMasterDataMultiSelect :field="field"
                                class="w-full"
                                :name="field.selectName"
                                v-model="filters[field.name].value" 
                                :disabled="field.readOnly" 
                                :api="field.gridFilterSelectApi"
                                v-if="field.gridFilterType == 'master-data-multi-select'"
                                :staticOptions="field.gridFilterArray"
                                :disableStore="field.gridFilterDisableStore" 
                                :localized="field.localized"
                                :format="field.selectFormat" />
                            
                        </span>
                    </div>
                </div>
            </div>
            <Button :label="$t('btn.filter')" icon="pi pi-filter" class="m-4 p-button-outlined" @click="onFilter"  />

        </Sidebar>

        <!-- EDIT MODE DIALOG -->
        <Dialog v-model:visible="editDialogVisible" :style="{width: '85vw'}" :modal="true" v-if="editDialogVisible">
             <div class="grid">
                <div class="col-12 lg:col-4" v-for="field in fieldsForDialogEdit" :key="field.name">
                    <label :for="field.name">{{$t(field.label)}}</label>
                    <InputText 
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'string'" 
                        class="w-full"
                        v-model="editItem[field.name]" />
                    <InputText 
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        type="number" 
                        v-if="field.type == 'number'"
                        v-model="editItem[field.name]" />
                    <InputNumber
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        mode="decimal" :maxFractionDigits="field.digits"
                        v-if="field.type == 'decimal'"
                        v-model="editItem[field.name]" />
                    <!--<GenericDateTimeMaskV2 
                        v-if="field.type == 'date'"    
                        v-model="editItem[field.name]"
                        mask="99/99/9999 99:99:99"
                        :unmask="true" />-->
                    <Calendar 
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        v-if="field.type == 'date'"    
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="field.onlyDate ? false : true"
                        v-model="editItem[field.name]" />
                    <GenericBooleanDropdown
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'boolean'"
                        v-model="editItem[field.name]" 
                        class="w-full" />
                    <GenericCustomMasterDataAutocompleteV2
                        :ref="field.name + '_dialogEdit'"
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'select'"
                        :name="field.name"
                        v-model="editItem[field.updateField ?? field.name]" 
                        :api="field.selectApi"
                        :disableStore="field.disableStore"
                        :format="field.selectFormat" />
                    <GenericCustomAutocompleteV2
                        class="w-full"
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'select-simple'"
                        :name="field.name"
                        v-model="editItem[field.updateField ?? field.name]" 
                        :api="field.selectApi"
                        :format="field.selectFormat" />
                    <Textarea
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        v-if="field.type == 'textarea'"
                        v-model="editItem[field.name]" />
                    <GenericCustomAutocompleteV2 
                        v-model="editItem[field.name]" 
                        class="w-full" 
                        v-if="field.type == 'static-select'" 
                        :staticOptions="field.staticOptions"
                        :refreshValueOnLoad="true"
                        :format="field.format" />
                </div>
            </div>
             <template #footer>
                <Button :label="$t('btn.save')" icon="pi pi-save" @click="dialogEditSave" autofocus />
            </template>
        </Dialog>

        <Dialog v-model:visible="detailsDialogVisible" :style="{width: '85vw'}" :modal="true" v-if="configuration.showDetailDialog">
            <div class="grid">
                <div class="col-12 lg:col-4" v-for="field in configuration.columns" :key="field.name">
                    <LabelField :label="$t(field.label)" 
                        v-if="field.type == 'date'"
                        :value="detailsRecord[field.name] ? utils.formatDateTime(utils.dateToCurrentTimeZone(detailsRecord[field.name])) : null" />
                    <LabelField :label="$t(field.label)" 
                        v-else-if="field.type == 'boolean'"
                        :value="detailsRecord[field.name] ? $t('yes'): $t('no')" />
                    <LabelField 
                        v-else
                        :label="$t(field.label)" :value="detailsRecord[field.name]" />
                </div>
            </div>
        </Dialog>

        <Dialog v-model:visible="prevSuccDialogVisible" showGridlines :modal="true" v-if="configuration.showPrevSuccDialog">
            <div class="grid">
                <div class="col-12">
                    <DataTable :value="prevSuccColumnRecords" tableStyle="min-width: 50rem">
                        <Column field="key" header="Field"></Column>
                        <Column field="prev" header="Prev"></Column>
                        <Column field="succ" header="Succ"></Column>
                    </DataTable>
                </div>
            </div>
        </Dialog>
</template>